import React, { Component } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getAssetByParentId } from '../../../../api/api';
import FileCell from './FileCell';

export const RenderSelectValue = ({ input, options, label, multi }) => {
  const { value } = input || {};
  const { label: displayValue } = multi ?
    { label: (value || []).map(v => v.label).join(', ') } :
    (options || []).find(o => o.value === value) || {};

    return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="form-container">
        {displayValue}
      </div>
    </FormGroup>
  );
};

export const RenderValue = ({ input, label, labelStyle }) => {
  const { value } = input || {};

  return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel style={labelStyle || {}}>{label}</ControlLabel>}
      <div className="form-container read-only">
        {value}
      </div>
    </FormGroup>
  );
};

export const RenderWysiwyg = ({ input, label }) => {
  const { value } = input || {};

  return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div
        className="form-container read-only"
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </FormGroup>
  );
};

export const RenderFile = ({ input, label }) => {
  const { value } = input || {};

  return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="form-container">
        <FileCell value={value} />
      </div>
    </FormGroup>
  );
};

const getRelationshipType = field => {
  const { opts } = field || {};

  const { relationshipType } = opts || {};

  return relationshipType;
};

const getRelationshipField = field => {
  const { opts } = field || {};

  const { relationshipField } = opts || {};

  return relationshipField;
};

export class RenderRelationshipValue extends Component {
  constructor(props) {
    super(props);
    this.loadValue = this.loadValue.bind(this);
    this.state = { relationship: null };
  }
  componentDidMount() {
    const { value } = this.props.input || {};

    if (!value) return;

    this.loadValue();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.input.value === this.props.input.value) return;

    this.loadValue();
  }
  async loadValue() {
    const type = getRelationshipType(this.props.field);
    const { value } = this.props.input || {};
    if (!value) return;

    try {
      const relationship = await getAssetByParentId({ id: value, type });
      this.setState({ relationship });
    } catch (err) {
      // TODO handle error
    }
  }
  render() {
    const { input, label, field } = this.props;
    const { relationship } = this.state;
    const relationshipField = getRelationshipField(field);

    return (
      <FormGroup controlId={input.name}>
        {label && <ControlLabel>{label}</ControlLabel>}
        <div className="form-container">
          {relationship &&
            <Link
              target="_blank"
              to={
                `/pages/${getRelationshipType(field)}/${encodeURIComponent(relationship._id)}`
              }
            >
              {(relationship.data || {})[relationshipField]}
            </Link>}
        </div>
      </FormGroup>
    );
  }
}

export const RenderSwitchValue = ({ input, label }) => {
  const { value } = input || {};
  return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="form-container">
        {/* TODO replace with icons */}
        {value === true && <span><span className="ti ti-check" /></span>}
        {value !== true && <span><span className="ti ti-close" /></span>}
      </div>
    </FormGroup>
  );
};

export const RenderVideoValue = ({ input, label }) => {
  const { value } = input || {};
  return (
    <FormGroup controlId={input.name}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="form-container">
        {value &&
          <iframe
            width="560"
            height="315"
            src={value}
            frameborder="0"
            allow="autoplay;
            encrypted-media"
            allowfullscreen
          />}
      </div>
    </FormGroup>
  );
};



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/ReadOnlyFields.js